import {get as getConfig} from '@mailonline/dmg-ads-core/src/config'
import { createLog } from '@mailonline/dmg-ads-core/src/ads-utils/log'
import { queryParams } from '@mailonline/dmg-ads-core/src/ads-utils/browser'
import device from './device'
import pLocation from './geo'

const log = createLog('context')

const isTCFV2Jurisdiction = async (getConfig) => {
  const geo = (await pLocation)?.Country?.toLowerCase()
  return getConfig('tcfv2.enabled', geo && getConfig('tcfv2.enabledGeos', []).includes(geo))
}

// If platform===AMP provide ccpa context
// Switch to cmp.v2 when released

const isAmpMessage = (event, type) => (
  event.source === window.parent &&
  event.origin !== window.location.origin &&
  event.data &&
  event.data.sentinel === 'amp' &&
  event.data.type === type
)

async function consentStringFromAmp({ log }) {
  return new Promise((resolve) => {
    const handler = (event) => {
      if (!isAmpMessage(event, 'consent-data')) {
        return
      }
      log('consentMetaData', event.data.consentMetadata)
      log('consentString', event.data.consentString)
      window.removeEventListener('message', handler)
      resolve(event.data.consentString)
    }

    window.addEventListener('message', handler)

    window.parent.postMessage(
      {
        sentinel: 'amp',
        type: 'send-consent-data'
      },
      '*'
    )
  })
}

const pluginContext = async () => {
  const PageCriteria = await pLocation

  let context = {
    pageCriteria: {
      pageType: global.PageContext?.pageData?.type,
      device,
      isMobile: device === "mobile",
      geo: PageCriteria?.Country || 'null',
      ...PageCriteria,
      ...((global.getPageCriteria && global.getPageCriteria()) || {})
    }
  }

  if (context.pageCriteria.isAMP) {
    const IABUSPrivacy_String = await consentStringFromAmp(log)
    context.ccpaOpts = { IABUSPrivacy_String }
    log('AMP ccpaOpts', IABUSPrivacy_String)
  }

  try {
    context = { 
      device, 
      isTCFV2Jurisdiction, 
      location: global.location, 
      pageGeoInfo: () => pLocation, 
      queryParams, 
      pageMeta: {...((global.getPageMetadata && global.getPageMetadata()) || {})},
      ...context
    }
  } catch (e) {
    log.warn('Error initialising context', e)
  }

  return context
}

export default pluginContext
